<template>
  <div>
    <h4>{{ $t(`module.type.${type}`) }}</h4>
    <b-row>
      <b-col
        v-for="card in cards"
        :key="card.id"
        sm="6"
        md="4"
        class="mb-2"
      >
        <preparation-card
          :item="card"
          :type="type"
          is-module
          :active="selectedCard === card.id"
          @change="onCardChange"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import PreparationCard from '@/components/preparation-card';

  export default {
    name: 'PreparationCardsComponent',
    components: {
      PreparationCard,
    },
    props: {
      cards: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        selectedCard: null,
      };
    },
    methods: {
      onCardChange(module) {
        const { type } = this;
        this.selectedCard = module;
        this.$emit('change', { type, module });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
